import { render, staticRenderFns } from "./MessagePage.vue?vue&type=template&id=c4fe62bc&scoped=true&"
import script from "./MessagePage.vue?vue&type=script&lang=js&"
export * from "./MessagePage.vue?vue&type=script&lang=js&"
import style0 from "./MessagePage.vue?vue&type=style&index=0&id=c4fe62bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fe62bc",
  null
  
)

export default component.exports